/**
 * Pure guard for whether the Traceway SDK should initialise, split out from
 * Traceway.ts so it's unit-testable via `tsx --test` without importing
 * Traceway.ts itself: that file reads `import.meta.env` at module scope,
 * which only exists under Vite's runtime (dev server / build), not under
 * plain tsx/node — importing it directly in a unit test throws
 * "Cannot read properties of undefined (reading 'VITE_TRACEWAY_CONNECTION_STRING')".
 *
 * A type predicate so callers (Traceway.ts) get `connectionString` narrowed
 * to `string` without a cast.
 */
export function isTracewayEnabled(
	connectionString: string | undefined | null
): connectionString is string {
	return (
		typeof connectionString === 'string' && connectionString.trim().length > 0
	)
}
